<template>
    <div>
        <div class="flex jc-sb">
            <label class="flex-33 mr-2">Premium</label>
            <label class="flex-33 ml-2 mr-2">Coverage</label>
            <div class="flex-33 ml-2">&nbsp;</div>
        </div>

        <div v-for="(option, index) in options" :key="`coverage-option-${index}`" class="flex jb-sb mt-2">
            <div class="flex-33 mr-1">
                <input disabled type="text" :value="`$${option.premium.toLocaleString()}`" />
            </div>

            <div class="flex-33 ml-1 mr-1">
                <input disabled type="text" :value="`$${option.coverage.toLocaleString()}`" />
            </div>

            <div class="flex-33 ml-1">
                <button type="button" class="danger" @click="onDeleteOption(index)">
                    <i class="material-icons">delete</i>
                </button>
            </div>
        </div>

        <form class="flex fl-sb mt-2" @submit.prevent="onAddNewOption">
            <div class="flex-33 mr-1">
                <input type="text" required v-model="premium" />
            </div>

            <div class="flex-33 ml-1 mr-1">
                <input type="text" required v-model="coverage" />
            </div>

            <div class="flex-33 ml-1">
                <button type="submit">
                    <i class="material-icons">add</i>
                </button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    props: {
        options: {
            required: true,
            type: Array
        }
    },

    data () {
        return {
            coverage: "",
            premium: ""
        }
    },

    methods: {
        onAddNewOption () {
            try {
                if (this.coverage.length === 0) {
                    throw new Error("Coverage cannot be empty")
                }

                if (this.premium.length === 0) {
                    throw new Error("Premium cannot be empty")
                }

                const coverage = parseFloat(this.coverage.trim())
                const premium = parseFloat(this.premium.trim())

                if (isNaN(coverage)) {
                    throw new Error("Coverage is an invalid number")
                }

                if (isNaN(premium)) {
                    throw new Error("Premium is an invalid number")
                }

                const options = this.options.concat([{ coverage, premium }])

                this.coverage = ""
                this.premium = ""

                this.$emit("change", options)
            } catch (ex) {
                this.$eventManager.emit("add-toast", { message: ex.message, type: "error" })
            }
        },

        onDeleteOption (index) {
            this.options.splice(index, 1)

            this.$emit("change", this.options)
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/add-facility-page/CoverageRateOptions.vue